





































































































































































































import {Component, Watch} from 'vue-property-decorator'
import BigNumber from 'bignumber.js'
import {Portal} from 'portal-vue'
import {$} from '@/facade'
import {SwapStep} from '@/enums/SwapStep'
import {NeoHelper} from '@/helpers/NeoHelper'
import {BalanceResponse, ShrikeHelper} from '@/helpers/ShrikeHelper'
import {TokensTableItemsCollection} from '@/model/collection/TokensTableItemsCollection'
import {TokensTableItem} from '@/model/resource/TokensTableItem'
import {getN3InvocationBuilder} from '@/model/wallets/invocationsBuilder'
import {FlamingoOrderBook} from '@/libs/flamingo-orderbook/FlamingoOrderbook'
import {TFlamingoOrderBookToken} from '@/libs/flamingo-orderbook/types'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import SwapRejectedByTheUserStep from '@/components/SwapRejectedByTheUserStep.vue'
import SwapLoadingStep from '@/components/SwapLoadingStep.vue'
import SwapFormStep from '@/components/SwapFormStep.vue'
import SwapInsufficientGasStep from '@/components/SwapInsufficientGasStep.vue'
import SwapLoadingTransactionStep from '@/components/SwapLoadingTransactionStep.vue'
import SwapReviewStep from '@/components/SwapReviewStep.vue'
import SwapSwappedStep from '@/components/SwapSwappedStep.vue'
import SwapUnexpectedErrorStep from '@/components/SwapUnexpectedErrorStep.vue'

@Component({
  components: {
    SwapLoadingStep,
    SwapUnexpectedErrorStep,
    SwapInsufficientGasStep,
    SwapSwappedStep,
    SwapLoadingTransactionStep,
    SwapRejectedByTheUserStep,
    SwapReviewStep,
    SwapFormStep,
    Portal,
  },
  computed: {
    SwapStep() {
      return SwapStep
    },
  },
})
export default class SwapModal extends MixinScreenSize {
  tokensTableItemsCollection = new TokensTableItemsCollection()

  currentStep: SwapStep = SwapStep.LOADING

  accountBalance: BalanceResponse[] = []

  allowedSlippageInPercentage = 0.5

  tokenToReceive: TokensTableItem | null = null
  tokenToUse: TokensTableItem | null = null

  amountToReceive = '0'
  amountToUse = '0'

  amountToReceiveInDollar = '0'
  amountToUseInDollar = '0'

  maxAmountAvailableToUse = '0'
  minimumReceived = '0'
  priceInverse = '0'
  transactionHash = ''

  isAmountToReceiveValid = true
  isAmountToUseValid = true
  isSlippageHigh = false
  isMyWalletPage = false

  pairIds: number[] = []
  pathRoute: TFlamingoOrderBookToken[] = []

  tokenToUseOptions: TokensTableItem[] = []
  tokenToReceiveOptions: TokensTableItem[] = []

  swappableTokensSymbol = FlamingoOrderBook.listSwappableTokens()

  poolingInterval: any = null

  get canBeClosed() {
    return (
      this.currentStep !== SwapStep.WAITING_SIGNATURE &&
      this.currentStep !== SwapStep.VALIDATING_TRANSACTION
    )
  }

  closeEvent() {
    this.resetValues()

    if (this.poolingInterval) {
      clearInterval(this.poolingInterval)
      this.poolingInterval = null
    }

    this.$emit('close')
  }

  resetValues() {
    this.tokenToReceiveOptions = []
    this.tokenToUseOptions = []

    this.allowedSlippageInPercentage = 0.5

    this.tokenToReceive = null
    this.tokenToUse = null

    this.amountToReceive = '0'
    this.amountToUse = '0'

    this.amountToReceiveInDollar = '0'
    this.amountToUseInDollar = '0'

    this.maxAmountAvailableToUse = '0'
    this.minimumReceived = '0'
    this.priceInverse = '0'
    this.transactionHash = ''

    this.pairIds = []
    this.pathRoute = []

    this.isAmountToReceiveValid = true
    this.isAmountToUseValid = true

    this.isSlippageHigh = false

    this.currentStep = SwapStep.LOADING
  }

  async openEvent({
    token,
    isMyWalletPage = false,
  }: {
    token: TokensTableItem
    isMyWalletPage: boolean
  }) {
    this.currentStep = SwapStep.LOADING
    this.isMyWalletPage = isMyWalletPage

    $.await.init('populateAccountBalance')

    this.poolingInterval = setInterval(() => {
      this.setAmountToReceive()
    }, 15000)

    if (isMyWalletPage) {
      this.tokenToUse = token
    } else {
      this.tokenToReceive = token
    }

    this.tokensTableItemsCollection.active = true
    this.tokensTableItemsCollection.isDeprecated = false
    this.tokensTableItemsCollection.minOrder = 0
    this.tokensTableItemsCollection.perPage = this.tokensTableItemsCollection.total

    const promises: Array<Promise<any>> = [
      this.populateAccountBalance(),
      this.tokensTableItemsCollection.queryAsPage(),
    ]

    await Promise.all(promises)

    this.populateTokenToUseOptions()
    this.populateTokenToReceiveOptions()

    $.await.done('populateAccountBalance')

    if (this.tokenToUse) {
      this.updateMaxAmountForTokenToUse()
    }

    if (this.tokenToUse && this.tokenToReceive) {
      await this.initializeSwapRoute()
      this.handleAmountToUseInput('0')
    }

    this.currentStep = SwapStep.FORM
    this.$emit('open')
  }

  async handleTokenSelected(val: TokensTableItem) {
    if (this.isMyWalletPage) {
      this.tokenToReceive = val
    } else {
      this.tokenToUse = val
    }

    this.updateMaxAmountForTokenToUse()

    const tokenToUseSymbol = this.tokenToUse?.symbol
    const tokenToReceiveSymbol = this.tokenToReceive?.symbol

    if (!tokenToUseSymbol || !tokenToReceiveSymbol) {
      return
    }

    await this.initializeSwapRoute()
    this.handleAmountToUseInput('0')
  }

  async handleAmountToUseInput(val: string) {
    this.amountToUse = val

    const numericValue = parseFloat(val)

    if (val.trim() === '' || isNaN(numericValue) || numericValue === 0) {
      this.priceInverse = '0'
      this.minimumReceived = '0'
      this.amountToReceive = '0'
      this.amountToReceiveInDollar = '0'
      this.amountToUseInDollar = '0'
      return
    }

    this.setAmountToUseInDollar()

    await this.setAmountToReceive()

    this.setPriceInverse()
    this.setMinimumReceived()
    this.setAmountToReceiveInDollar()
  }

  async handleReviewProceedClick() {
    try {
      this.currentStep = SwapStep.WAITING_SIGNATURE

      const gasTokenBalance = this.accountBalance.find(
        balance => balance.token.symbol === 'GAS'
      )

      if (!gasTokenBalance) {
        this.currentStep = SwapStep.INSUFFICIENT_GAS
        return
      }

      const n3InvocationBuilder = getN3InvocationBuilder()

      const standardConvertInvocationBuilder = n3InvocationBuilder.standardConvertInvocation(
        {
          amountToUse: this.amountToUse,
          pairIds: this.pairIds,
          path: this.pathRoute,
          minAmountOut: this.minimumReceived,
        }
      )

      this.transactionHash = await $.walletAdapter.invokeN3Wallet(
        standardConvertInvocationBuilder
      )

      if (!this.transactionHash) {
        this.currentStep = SwapStep.UNKNOWN_ERROR
        return
      }

      this.currentStep = SwapStep.VALIDATING_TRANSACTION

      const isTransactionValid = await NeoHelper.validateTransaction(
        this.transactionHash
      )

      if (!isTransactionValid) throw new Error()

      this.currentStep = SwapStep.SWAPPED
    } catch (error) {
      console.error(error)

      const walletError =
        typeof error === 'object' && error !== null
          ? (error as {message?: string; description?: string})
          : {}

      const isNeonWalletRejected = Boolean(
        walletError.message?.includes('rejected by the user')
      )

      const isNeoLineWalletRejected =
        walletError.description ===
        'The user cancels, or refuses the dapps request'

      if (isNeonWalletRejected || isNeoLineWalletRejected) {
        this.currentStep = SwapStep.REJECTED_BY_THE_USER
        return
      }

      this.currentStep = SwapStep.UNKNOWN_ERROR
    }
  }

  async handleUpdateAllowedSlippageInPercentage(allowedSlippage: number) {
    this.allowedSlippageInPercentage = allowedSlippage
    this.setMinimumReceived()
  }

  async handleFormProceedClick() {
    this.currentStep = SwapStep.REVIEW_FORM
  }

  handleMaxClick() {
    this.handleAmountToUseInput(this.maxAmountAvailableToUse)
  }

  populateTokenToUseOptions(): void {
    this.tokenToUseOptions = []

    this.accountBalance.forEach(balance => {
      const formattedBalanceSymbol =
        balance.token.symbol.charAt(0) === 'f'
          ? balance.token.symbol.slice(1)
          : balance.token.symbol

      if (formattedBalanceSymbol === this.tokenToReceive?.symbol) return

      const tokenSymbolToUse = this.swappableTokensSymbol.find(
        tokenSymbol => tokenSymbol === formattedBalanceSymbol
      )
      if (!tokenSymbolToUse) return

      const convertedTokenToUse = this.tokensTableItemsCollection.items.find(
        token => token.symbol === tokenSymbolToUse
      )
      if (!convertedTokenToUse) return

      this.tokenToUseOptions.push(convertedTokenToUse)
    })

    const seen = new Set<string>()

    this.tokenToUseOptions = this.tokenToUseOptions.filter(token => {
      if (!token.symbol) return false
      if (seen.has(token.symbol)) return false

      seen.add(token.symbol)

      return true
    })
  }

  populateTokenToReceiveOptions(): void {
    this.tokenToReceiveOptions = []

    this.swappableTokensSymbol.forEach(tokenSymbolToReceive => {
      if (tokenSymbolToReceive === this.tokenToUse?.symbol) return

      const convertedTokenToReceive = this.tokensTableItemsCollection.items.find(
        token => token.symbol === tokenSymbolToReceive
      )
      if (!convertedTokenToReceive) return

      this.tokenToReceiveOptions.push(convertedTokenToReceive)
    })
  }

  @Watch('$store.state.walletAdapter.n3.address')
  async onN3AddressChange(address: string | null) {
    if (!address) {
      this.accountBalance = []
      this.maxAmountAvailableToUse = '0'
      return
    }

    await this.populateAccountBalance()
    this.populateTokenToUseOptions()
    this.updateMaxAmountForTokenToUse()
  }

  private findBalanceForToken(
    token: TokensTableItem | null
  ): BalanceResponse | undefined {
    if (!token) {
      return undefined
    }

    const tokenHash = token.marketInformation?.hash?.toLowerCase()

    if (tokenHash) {
      const byHash = this.accountBalance.find(
        balance => balance.token.hash?.toLowerCase() === tokenHash
      )

      if (byHash) {
        return byHash
      }
    }

    const tokenSymbol = token.symbol?.toUpperCase()

    if (!tokenSymbol) {
      return undefined
    }

    return this.accountBalance.find(balance => {
      const balanceSymbol = balance.token.symbol
      const formattedSymbol =
        balanceSymbol.charAt(0) === 'f'
          ? balanceSymbol.slice(1).toUpperCase()
          : balanceSymbol.toUpperCase()

      return formattedSymbol === tokenSymbol
    })
  }

  private updateMaxAmountForTokenToUse() {
    const balance = this.findBalanceForToken(this.tokenToUse)

    this.maxAmountAvailableToUse = balance
      ? new BigNumber(balance.amount).toFixed()
      : '0'
  }

  private async initializeSwapRoute() {
    const tokenToUseSymbol = this.tokenToUse?.symbol
    const tokenToReceiveSymbol = this.tokenToReceive?.symbol

    if (!tokenToUseSymbol || !tokenToReceiveSymbol) {
      return
    }

    const {path, pairs} = FlamingoOrderBook.getTradingRoute([
      tokenToUseSymbol,
      tokenToReceiveSymbol,
    ])

    this.pairIds = pairs.map(pair => pair.pairId)

    this.pathRoute = path.map(pathSymbol =>
      FlamingoOrderBook.getFlamingoToken(pathSymbol)
    )
  }

  private setPriceInverse() {
    this.priceInverse = new BigNumber(this.amountToUse)
      .times(this.amountToReceive)
      .toFixed()
  }

  private async setAmountToReceive() {
    await $.await.run('populateAmountToReceive', async () => {
      const tokenToUseSymbol = this.tokenToUse?.symbol
      if (!tokenToUseSymbol) return

      const flamingoTokenToUse = FlamingoOrderBook.getFlamingoToken(
        tokenToUseSymbol
      )

      const amountToReceive = await FlamingoOrderBook.calculateAmountToReceive(
        flamingoTokenToUse,
        this.pathRoute,
        this.pairIds,
        this.amountToUse
      )

      this.amountToReceive = Number(amountToReceive).toFixed(
        this.tokenToReceive?.marketInformation?.decimals ?? 0
      )
    })
  }

  private setAmountToUseInDollar() {
    const currentPriceTokenToUse =
      this.tokenToUse?.marketInformation?.currentPrice ?? '0'

    this.amountToUseInDollar = new BigNumber(this.amountToUse)
      .times(currentPriceTokenToUse)
      .toNumber()
      .toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 8,
      })
  }

  private setAmountToReceiveInDollar() {
    const currentPriceToReceive =
      this.tokenToReceive?.marketInformation?.currentPrice ?? '0'

    this.amountToReceiveInDollar = new BigNumber(this.amountToReceive)
      .times(currentPriceToReceive)
      .toNumber()

      .toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 8,
      })
  }

  private setMinimumReceived() {
    const slippageFormatted = this.allowedSlippageInPercentage / 100
    const amountToReceive = new BigNumber(this.amountToReceive)
    const slippageAmount = amountToReceive.times(slippageFormatted)

    this.minimumReceived = amountToReceive
      .minus(slippageAmount)
      .toFixed(this.tokenToReceive?.marketInformation?.decimals ?? 0)
  }

  private async populateAccountBalance() {
    try {
      const address = $.walletAdapter.n3Address
      if (!address) throw new Error()

      this.accountBalance = await ShrikeHelper.getBalance(address)
    } catch (error) {
      console.error('[SwapModal] populateAccountBalance failed', error)
      this.threatError('components.SwapModal.unknownError')
    }
  }

  private threatError(i18nKey: string) {
    $.toast.abort(i18nKey)
    $.modal.close('swapModal')
  }
}
